/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfPaymentMethodDto } from '../../models/paginated-dto-of-payment-method-dto';

export interface GetAllPaymentMethods$Params {
}

export function getAllPaymentMethods(http: HttpClient, rootUrl: string, params?: GetAllPaymentMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfPaymentMethodDto>> {
  const rb = new RequestBuilder(rootUrl, getAllPaymentMethods.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfPaymentMethodDto>;
    })
  );
}

getAllPaymentMethods.PATH = '/api/v1/payment-methods';
